import React from 'react';
import { CalendarIcon, CheckIcon, ShieldCheckIcon, ClockIcon, MapPinIcon, ShieldIcon } from 'lucide-react';
export function Availability() {
  const includedServices = ['Professionele beveiligingsuitrusting', 'Directe communicatie', 'Gedetailleerde rapportages', 'Eigen vervoer', 'Flexibele inzetbaarheid', 'BHV-expertise'];
  return <section className="py-16 border-b border-gray-800" data-id="element-33">
      <div className="max-w-6xl mx-auto" data-id="element-34">
        <h2 className="text-3xl font-bold mb-8 flex items-center gap-3" data-id="element-35">
          <CalendarIcon className="w-8 h-8 text-orange-500" data-id="element-36" />
          Beveiligingsdiensten & Tarieven
        </h2>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-37">
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg" data-id="element-38">
            <h3 className="text-xl font-semibold mb-4 flex items-center gap-2" data-id="element-39">
              <ShieldCheckIcon className="w-5 h-5 text-orange-500" data-id="element-40" />
              Beveiligingsdiensten
            </h3>
            <div className="space-y-4" data-id="element-41">
              <div className="flex items-start gap-3" data-id="element-42">
                <MapPinIcon className="w-5 h-5 text-gray-400 mt-1 flex-shrink-0" data-id="element-43" />
                <div data-id="element-44">
                  <div className="font-medium text-gray-300 mb-1" data-id="element-45">
                    Werkgebied:
                  </div>
                  <div data-id="element-46">Amsterdam en omgeving</div>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-47">
                <ClockIcon className="w-5 h-5 text-gray-400 mt-1 flex-shrink-0" data-id="element-48" />
                <div data-id="element-49">
                  <div className="font-medium text-gray-300 mb-1" data-id="element-50">
                    Beschikbaarheid:
                  </div>
                  <div data-id="element-51">Flexibel inzetbaar, in overleg te bepalen</div>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-52">
                <CalendarIcon className="w-5 h-5 text-gray-400 mt-1 flex-shrink-0" data-id="element-53" />
                <div data-id="element-54">
                  <div className="font-medium text-gray-300 mb-1" data-id="element-55">
                    Aanvraagtermijn:
                  </div>
                  <div data-id="element-56">Bij voorkeur minimaal 48 uur van tevoren</div>
                </div>
              </div>
            </div>
            <div className="mt-6 p-4 bg-gray-700 rounded-lg" data-id="element-57">
              <div className="font-medium mb-2 flex items-center gap-2" data-id="element-58">
                <ShieldIcon className="w-5 h-5 text-orange-500" data-id="element-59" />
                <span data-id="element-60">Type beveiligingsdiensten:</span>
              </div>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-61">
                <li className="flex items-center gap-2" data-id="element-62">
                  <CheckIcon className="w-4 h-4 text-green-500" data-id="element-63" />
                  <span data-id="element-64">Objectbeveiliging</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-65">
                  <CheckIcon className="w-4 h-4 text-green-500" data-id="element-66" />
                  <span data-id="element-67">Winkelbeveiliging</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-68">
                  <CheckIcon className="w-4 h-4 text-green-500" data-id="element-69" />
                  <span data-id="element-70">Toegangscontrole</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-71">
                  <CheckIcon className="w-4 h-4 text-green-500" data-id="element-72" />
                  <span data-id="element-73">Evenementenbeveiliging</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg" data-id="element-74">
            <h3 className="text-xl font-semibold mb-4 flex items-center gap-2" data-id="element-75">
              <ShieldCheckIcon className="w-5 h-5 text-orange-500" data-id="element-76" />
              Tarieven
            </h3>
            <div className="mb-6" data-id="element-77">
              <div className="text-2xl font-bold text-orange-500 mb-2 flex items-center justify-center p-4 border border-orange-500/30 rounded-lg" data-id="element-78">
                Op aanvraag
              </div>
              <p className="text-gray-400 mt-4" data-id="element-79">
                Tarieven worden bepaald op basis van type dienst, duur, tijdstip
                en specifieke vereisten. Neem contact op voor een persoonlijke
                offerte toegespitst op uw beveiligingsbehoeften.
              </p>
            </div>
            <div data-id="element-80">
              <h4 className="font-medium mb-4 flex items-center gap-2 border-b border-gray-700 pb-2" data-id="element-81">
                <ShieldCheckIcon className="w-5 h-5 text-orange-500" data-id="element-82" />
                Inbegrepen bij de dienstverlening:
              </h4>
              <ul className="space-y-3 grid grid-cols-1 sm:grid-cols-2 gap-x-2" data-id="element-83">
                {includedServices.map((item, index) => <li key={index} className="flex items-center gap-2" data-id="element-84">
                    <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-85" />
                    <span data-id="element-86">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}